import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import { useEffect, useState } from "react";
import { Box, Button, Chip, IconButton, ListItemIcon, Paper, Typography } from "@mui/material";
import { styled } from "@mui/system";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import AddOrEditModal from "./AddOrEditModal/AddOrEditModal";
import { DragIndicator, SwapVert } from "@mui/icons-material";
import SearchBar from "components/ReusableComponents/SearchBar";
import { studioAttrGrpAttrAssocObj } from "../StudioAttributes/data";
import { attrTableStrColumnsObj, addOrEditModelAction, attrConditionalDisplayColObj } from "components/PimDashboard/data";
import { studioAttrGrpTableStrColumnsObj } from "./data";
import { grey } from "@mui/material/colors";
import { datatypes } from "data/globalData";
import { Reorder } from "framer-motion";
import ArrangeGroupModal from "./ArrangeGroupModal/ArrangeGroupModal";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { StudioDashboardState } from "context/StudioDashboardContext";

// Styled component for resizable box
const ResizableBox = styled(Paper)(({ theme, width }) => ({
	width: width,
	height: "100%", // Set the height as per your requirement
	overflowY: "scroll",
	resize: "horizontal",
	backgroundColor: theme.palette.primary.grey,
}));

const ResizableDivider = styled(Divider)({
	cursor: "ew-resize",
	width: "4px", // Set the width of the divider as per your requirement
});
const RenderChips = ({ values }) => {
	if (values)
		return (
			<Box display="flex" flexWrap="wrap" columnGap="2%">
				{Object.keys(values).map((row) => {
					return <Chip label={row?.split("_").join(" ").toLocaleUpperCase()} />;
				})}
			</Box>
		);
	else return <></>;
};
const ListSubHeader = ({ attrGrp, handleAddFunction }) => {
	return (
		<Box display="flex" justifyContent="space-between" alignItems="end" pl={2}>
			<Typography variant="body2" color={grey[600]}>
				{attrGrp?.name}
			</Typography>
			<IconButton size="small" onClick={() => handleAddFunction(attrGrp)}>
				<AddRoundedIcon />
			</IconButton>
		</Box>
	);
};
export const attrColStyle = { width: "20%", height: 50, overflow: "hidden" };
export const dependencyAttrColStyle = { width: "40%", overflow: "hidden" };
const StudioAttributeGroups = ({ collection }) => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { attrGroupsWithAttr, setAttrGroupsWithAttr } = StudioDashboardState();
	const [box1Width, setBox1Width] = useState("20%");
	const [box2Width, setBox2Width] = useState("80%");
	const [addOrEditModal, setAddOrEditModal] = useState(false);
	const [arrangeGrpModal, setArrangeGrpModal] = useState(false);
	const [modalAction, setModalAction] = useState(addOrEditModelAction.CREATE);
	const [selectedAttrGroup, setSelectedAttrGroup] = useState();
	const [attrNameArr, setAttrNameArr] = useState();
	const [updatedAttrNameArr, setUpdatedAttrNameArr] = useState();
	const [attrGroupsState, setAttrGroupState] = useState({});
	const [search, setSearch] = useState("");

	const [attrGroupsCollectionState, setAttrGroupCollectionState] = useState({});
	useEffect(() => {
		const obj = Object.values(attrGroupsWithAttr)
			.filter((row) => row[attrTableStrColumnsObj.collection_type.key] === collection.key)
			.reduce((acc, row) => {
				acc[row.group_id] = row;
				return acc;
			}, {});

		setAttrGroupCollectionState({ ...obj });
		setAttrGroupState({ ...obj });
	}, [attrGroupsWithAttr]);

	const handleResize = (event) => {
		const box1NewWidth = `${event.clientX}px`;
		const box2NewWidth = `${window.innerWidth - event.clientX}px`;
		if (event.clientX < 400 && event.clientX > 150) {
			setBox1Width(box1NewWidth);
			setBox2Width(box2NewWidth);
		}
	};

	const handleRemoveEventListener = () => {
		window.removeEventListener("mousemove", handleResize);
		window.removeEventListener("mouseup", handleRemoveEventListener);
	};
	const handleEditClick = () => {
		setAddOrEditModal(true);
		setModalAction(addOrEditModelAction.UPDATE);
	};
	const handleAttrGrpSelect = async (attrGrp) => {
		setSelectedAttrGroup(attrGrp);
		setAttrNameArr(attrGrp[studioAttrGrpAttrAssocObj]?.map((row) => row[attrTableStrColumnsObj.name.key]));
	};

	function handleSearchSubmit() {
		if (search) {
			let newObj = {};
			let regex = new RegExp(search, "i");
			Object.keys(attrGroupsCollectionState).forEach((attribute) => {
				if (regex.test(attrGroupsCollectionState[attribute].name)) {
					newObj[attribute] = attrGroupsCollectionState[attribute];
				}
			});
			setAttrGroupState(newObj);
		} else setAttrGroupState({ ...attrGroupsCollectionState });
	}
	const handleAddAttrGrpFunction = (attrGrp) => {
		setAddOrEditModal(true);
		setSelectedAttrGroup(attrGrp);
		setModalAction(addOrEditModelAction.CREATE);
	};
	const handleArrangeGroupClick = () => {
		setArrangeGrpModal(true);
	};
	const handleAttributeReoredr = (valArr) => {
		setAttrNameArr(valArr);
		setUpdatedAttrNameArr(valArr);
	};
	const handleSaveReorderedAttrClick = async () => {
		setLoadingOpen(true);
		try {
			const res = await axios.put("/api/studio_attr_master/reorder_attributes", updatedAttrNameArr);
			let attrMapObj = updatedAttrNameArr?.reduce((acc, row, i) => {
				acc[row] = i;
				return acc;
			}, {});
			let grpData = {
				...selectedAttrGroup,
				[studioAttrGrpAttrAssocObj]: selectedAttrGroup[studioAttrGrpAttrAssocObj]
					?.map((row) => {
						if (attrMapObj[attrTableStrColumnsObj.key.key] >= 0)
							return { ...row, [attrTableStrColumnsObj.sort_no.key]: attrMapObj[attrTableStrColumnsObj.names.key] };
						else return row;
					})
					.sort((a, b) => a[attrTableStrColumnsObj.sort_no.key] - b[attrTableStrColumnsObj.sort_no.key]),
				res,
			};
			setSelectedAttrGroup(grpData);

			setAttrGroupsWithAttr({
				...attrGroupsWithAttr,
				[selectedAttrGroup[studioAttrGrpTableStrColumnsObj.group_id.key]]: grpData,
			});
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Attribute Reorder Saved",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		} catch (error) {
			setSnackBarOpen(true);
			console.log(error);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};
	return (
		<Stack sx={{ display: "flex", flexDirection: "row", height: "79vh", width: "100%" }}>
			<ResizableBox width={box1Width} sx={{ position: "relative" }}>
				<Box display={"flex"} p={1} flexWrap={"wrap"}>
					{/* <InputLabel>{"Search"}</InputLabel> */}
					<SearchBar
						value={search}
						setValue={setSearch}
						placeholder="Search Attribute"
						submitFunction={handleSearchSubmit}
						sx={{
							p: "2px",
						}}
						iconSx={{
							p: "2px",
							pt: 1,
							pb: 1,
						}}
					/>{" "}
				</Box>

				<List>
					{Object.keys(attrGroupsState).map((key, index) => {
						const attrGrp = attrGroupsState[key];
						return (
							<ListItem key={index} component="div" disablePadding>
								<ListItemButton
									sx={{ height: "40px" }}
									onClick={() => handleAttrGrpSelect(attrGrp)}
									selected={selectedAttrGroup?.group_id === attrGrp.group_id}>
									<ListItemText sx={{ textTransform: "capitalize" }} primary={`${attrGrp.name}`} />
								</ListItemButton>
							</ListItem>
						);
					})}
				</List>

				<Box position="absolute" bottom={0} left={0} width="100%" sx={{ background: "white" }}>
					<Divider orientation="horizontal" />

					<Button
						startIcon={<AddRoundedIcon />}
						onClick={() => handleAddAttrGrpFunction()}
						fullWidth
						sx={{ alignItems: "left", textTransform: "capitalize" }}>
						New Attribute Group
					</Button>
					<Divider orientation="horizontal" />
					<Button startIcon={<SwapVert />} fullWidth onClick={handleArrangeGroupClick} sx={{ textTransform: "capitalize" }}>
						Arrange Groups
					</Button>
				</Box>
			</ResizableBox>

			<ResizableDivider
				onMouseDown={(event) => {
					window.addEventListener("mousemove", handleResize);
					window.addEventListener("mouseup", handleRemoveEventListener);
				}}
			/>

			<ResizableBox width={box2Width}>
				{selectedAttrGroup ? (
					<Stack width="100%" boxSizing="border-box" p={1} spacing={1}>
						<Box display="flex" justifyContent="space-between" pl={1} pr={1}>
							<Typography variant="h5" textTransform="capitalize">
								Attribute Group - {selectedAttrGroup?.name}
							</Typography>
							{/* <Box>
								<Button variant="contained" size="small" onClick={handleEditClick}>
									Edit
								</Button>
							</Box> */}
						</Box>
						<Divider orientation="horizontal" />
						<Box display="flex" flexWrap="wrap" columnGap="3%" rowGap="15px" p={1}>
							<Typography variant="body1" width="100%">
								Main Details
							</Typography>
							{Object.keys(studioAttrGrpTableStrColumnsObj)
								?.map((row) => studioAttrGrpTableStrColumnsObj[row])
								.sort((a, b) => a.sort_no - b.sort_no)
								.map((row) => {
									const value = selectedAttrGroup
										? typeof row?.value_getter === "function"
											? row?.value_getter(row.key, selectedAttrGroup)
											: selectedAttrGroup[row.key]
										: row?.data_type === datatypes.NUMBER.key
										? 0
										: "";
									return (
										<Stack {...attrColStyle} key={row.key}>
											<Typography variant="subtitle2" color={grey[600]}>
												{row?.name}
											</Typography>
											<Typography
												variant="h6"
												textTransform={row.key === "group_id" ? "lowercase" : "capitalize"}>
												{value}
											</Typography>
										</Stack>
									);
								})}

							{selectedAttrGroup?.data?.[attrConditionalDisplayColObj.key] && (
								<Stack {...attrColStyle}>
									<Typography variant="subtitle2" color={grey[600]}>
										{attrConditionalDisplayColObj?.name}
									</Typography>
									<Typography variant="h6" textTransform="capitalize">
										{selectedAttrGroup?.data?.[attrConditionalDisplayColObj.key]}
									</Typography>
								</Stack>
							)}
						</Box>
						{attrNameArr ? (
							<Box pt={2}>
								<Box display="flex" columnGap={2} alignItems="center">
									<Typography variant="h6" textTransform="capitalize">
										Arrange Attributes
									</Typography>
									<Button
										variant="contained"
										disabled={updatedAttrNameArr ? false : true}
										size="small"
										onClick={handleSaveReorderedAttrClick}>
										Save
									</Button>
								</Box>
								<Reorder.Group
									values={attrNameArr}
									axis="y"
									onReorder={handleAttributeReoredr}
									style={{
										border: `1px solid ${grey[200]}`,
										listStyleType: "none",
										height: "35vh",
										width: "40%",
										padding: 0,
									}}>
									{attrNameArr?.map((item) => (
										<Reorder.Item key={item} value={item}>
											<ListItem sx={{ border: `1px solid ${grey[200]}`, background: "white" }}>
												<ListItemIcon>
													<DragIndicator />
												</ListItemIcon>
												<ListItemText primary={item} />
											</ListItem>
										</Reorder.Item>
									))}
								</Reorder.Group>
							</Box>
						) : (
							<></>
						)}
					</Stack>
				) : (
					<></>
				)}
			</ResizableBox>
			{modalAction && (
				<AddOrEditModal
					action={modalAction}
					modalOpen={addOrEditModal}
					setModalOpen={setAddOrEditModal}
					attrGrpData={selectedAttrGroup}
					setAttrGrpData={setSelectedAttrGroup}
					collection={collection}
				/>
			)}
			<ArrangeGroupModal
				modalOpen={arrangeGrpModal}
				setModalOpen={setArrangeGrpModal}
				setAttrGroupsState={setAttrGroupState}
				attrGroupsState={attrGroupsState}
			/>
		</Stack>
	);
};

export default StudioAttributeGroups;
